<template>
    <ManageIntegrationBase
      :integration="integration"
      :show="show"
      :showAuthSuccess="showAuthSuccess"
      :title="$t('companySettings.integrations.dropbox.name')"
      @loadingStateChanged="reEmitLoadingStateChanged"
      @close="emitClose"
    >
      <VForm
        :onSubmit="emitClose"
        data-vv-scope="dropbox-edit"
        ref="form">
        <div slot="row">
          <VGrid>
            <div slot="gridItem" type="12">
              <p><strong>{{ $t('companySettings.integrations.dropbox.settings.folder') }}</strong> {{ dropboxFolder }}</p>

              <div v-if="integration.client_id">
              <BaseButton
                @click.native="openChooser"
                size="small"
                variant="tertiary"
                data-ec="manage_dropbox_modal"
                data-et="select_folder_button"
              >
                {{ folderButtonText }}
              </BaseButton>
              </div>
            </div>
          </VGrid>
          <hr>
        </div>

      </VForm>
      <template v-slot:cta>
        <div>
          <BaseButton
            v-if="integration.instance"
            @click.native="confirmDisconnection"
            variant="tertiary"
            size="small"
            data-ec="manage_dropbox_modal"
            data-et="disconnect_button"
          >
            <span>{{ $t('companySettings.integrations.disconnect.disconnect') }}</span>
          </BaseButton>
          <BaseButton
            @click.native="emitClose"
            subtype="submit"
            class="float-right"
            size="small"
            data-ec="manage_dropbox_modal"
            data-et="save_button"
          >
            <span>{{ $t('functional.save') }}</span>
          </BaseButton>
          <BaseButton
            @click.native="emitClose"
            variant="invisible"
            class="float-right"
            size="small"
            data-ec="manage_dropbox_modal"
            data-et="cancel_button"
          >
            <span>{{ $t('functional.cancel') }}</span>
          </BaseButton>
        </div>
      </template>
    </ManageIntegrationBase>
</template>

<script>
import { Loading } from 'element-ui';
import BaseButton from '@/components/library/buttons/BaseButton.vue';
import VForm from '@/components/deprecated/organisms/Form.vue';
import VGrid from '@/components/deprecated/organisms/Grid.vue';
import ManageIntegrationBase from '@/views/modals/integrations/ManageIntegrationBase.vue';
import integrationsManagementMixin from '@/mixins/integrationsManagementMixin';

export default {
  name: 'ManageDropbox',
  components: {
    ManageIntegrationBase,
    VForm,
    VGrid,
    BaseButton,
  },
  props: {
    show: {
      type: [Boolean],
      required: true,
    },
    showAuthSuccess: {
      type: [Boolean],
      required: true,
    },
    integration: {
      type: [Object],
      required: true,
    },
  },
  mixins: [
    integrationsManagementMixin,
  ],
  data() {
    return {
      settings: {
        folder: '',
      },
    };
  },
  mounted() {
    if (this.hasInstance && this.hasSettings) {
      this.settings = this.integration.instance.settings;
    }

    this.setupChooser();
  },
  watch: {
    hasSettings() {
      if (this.hasInstance) {
        this.copyIntegrationSettings();
      }
    },
  },
  computed: {
    dropboxFolder() {
      return this.settings.folder || this.$t('companySettings.integrations.dropbox.noFolderMessage');
    },
    folderButtonText() {
      if (this.settings.folder) {
        return this.$t('companySettings.integrations.dropbox.changeFolder');
      }
      return this.$t('companySettings.integrations.dropbox.chooseFolder');
    },
  },
  methods: {
    confirmDisconnection() {
      this.$emit('disconnect', this.$t('companySettings.integrations.disconnect.warning', { name: this.integration.title }), this.integration.slug);
      this.$emit('close');
    },
    setupChooser() {
      const dropboxChooserScript = document.createElement('script');
      dropboxChooserScript.setAttribute('src', 'https://www.dropbox.com/static/api/2/dropins.js');
      dropboxChooserScript.setAttribute('id', 'dropboxjs');
      dropboxChooserScript.setAttribute('data-app-key', this.integration.client_id);
      document.head.appendChild(dropboxChooserScript);
    },
    openChooser() {
      const options = {
        success: async (files) => {
          this.onPicked(files);
        },
        linkType: 'preview',
        multiselect: false,
        folderselect: true,
        sizeLimit: 1, // Only directories
      };

      window.Dropbox.choose(options);
    },
    onPicked(files) {
      const loadingInstance = Loading.service();

      this.$store.dispatch('integrations/DROPBOX_SET_FOLDER_FROM_SHARED_LINK', {
        link: files[0].link,
      }).then(() => {
        this.settings.folder = this.integration.instance.settings.folder;
      }).finally(() => {
        loadingInstance.close();
      });
    },
    emitClose() {
      this.$emit('close');
    },
    copyIntegrationSettings() {
      if (this.integration.instance.settings) {
        this.settings.folder = this.integration.instance.settings.folder;

        return;
      }

      this.settings.folder = null;
    },
  },
};
</script>
